// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qt-9";
export var arrowButtonContainer = "_qt-5";
export var arrowButtonIcon = "_qt-6";
export var carouselArrowButton = "_qt-2";
export var carouselElementContainer = "_qt-1";
export var currentSlide = "_qt-8";
export var left = "_qt-3";
export var otherSlide = "_qt-a";
export var productCarouselContainer = "_qt-0";
export var right = "_qt-4";
export var sliderOverflow = "_qt-7";